/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

export const resetScrollPosition = (selector) => {
  const divs = document.querySelectorAll(selector);

  divs.forEach(div => {
    // Reset transform
    if (div.style.transform) {
      // For IE(10) and firefox
      div.style.transform = 'translate3d(0px, 0px, 0px)';
    } else {
      // For chrome and safari
      div.style['-webkit-transform'] = 'translate3d(0px, 0px, 0px)';
    }

    // Reset scroll
    div.scrollTop = 0;
  });
};
